import httpClient from '../../services/http-client';
import { API_SUB_URL_USER } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_USER, LOAD_LIST_USER, LOAD_A_USER, UPDATE_A_USER, DELETE_A_USER,
} from '../actionTypes';

// Users
export const apiLoadListUser = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));
        
        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_USER}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_USER, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAUser = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_USER}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_USER, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAUserByPhone = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_USER}/phone/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_USER, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewUser = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_USER, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_USER, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAUser = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_USER}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_USER, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAUser = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_USER}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_USER, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};